import { BaseService } from "../../core/baseService";
import { ApiResult } from "../../core/types";
import {
  GetPaymentsParams,
  PaymentsListResponse,
  PaymentDebugInfo,
  RefreshPaymentStatusResponse,
  ExportPaymentsParams,
} from "../types/payments.types";

export interface IPaymentsService {
  getPayments(
    params?: GetPaymentsParams,
  ): Promise<ApiResult<PaymentsListResponse>>;
  debugPayments(): Promise<ApiResult<PaymentDebugInfo>>;
  refreshPaymentStatus(
    paymentId: string,
  ): Promise<ApiResult<RefreshPaymentStatusResponse>>;
  exportPayments(params?: ExportPaymentsParams): Promise<ApiResult<Blob>>;
}

export class PaymentsService extends BaseService implements IPaymentsService {
  async getPayments(
    params?: GetPaymentsParams,
  ): Promise<ApiResult<PaymentsListResponse>> {
    const queryParams = new URLSearchParams();

    if (params?.page) {
      queryParams.append("page", params.page.toString());
    }
    if (params?.pageSize) {
      queryParams.append("pageSize", params.pageSize.toString());
    }
    if (params?.status && params.status !== "All") {
      queryParams.append("status", params.status);
    }
    if (params?.roomNumber) {
      queryParams.append("roomNumber", params.roomNumber);
    }

    const url = `/api/admin/payments${queryParams.toString() ? "?" + queryParams.toString() : ""}`;

    return this.handleRequest<PaymentsListResponse>(this.client.get(url));
  }

  async debugPayments(): Promise<ApiResult<PaymentDebugInfo>> {
    return this.handleRequest<PaymentDebugInfo>(
      this.client.get("/api/admin/payments/debug"),
    );
  }

  async refreshPaymentStatus(
    paymentId: string,
  ): Promise<ApiResult<RefreshPaymentStatusResponse>> {
    return this.handleRequest<RefreshPaymentStatusResponse>(
      this.client.post(`/api/admin/payments/${paymentId}/refresh-status`),
    );
  }

  async exportPayments(
    params?: ExportPaymentsParams,
  ): Promise<ApiResult<Blob>> {
    const queryParams = new URLSearchParams();

    if (params?.format) {
      queryParams.append("format", params.format);
    }
    if (params?.status) {
      queryParams.append("status", params.status);
    }

    const url = `/api/admin/payments/export${queryParams.toString() ? "?" + queryParams.toString() : ""}`;

    return this.handleRequest<Blob>(
      this.client.get(url, {
        responseType: "blob",
      }),
    );
  }
}
